const CameraIcon = ({ strokeColor = '#808080' }) => {
  return (
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 795.1 795.1">
      <g id="Circles">
        <circle id="Grey_Bkg" data-name="Grey Bkg" cx="397.55" cy="397.55" r="388.66" fill="#4d4d4d" />
        <circle 
          id="Grey" 
          cx="397.55" 
          cy="397.55" 
          r="372.55" 
          fill="none" 
          stroke={strokeColor} 
          strokeWidth="50px" 
          strokeMiterlimit="10" 
        />
        <circle 
          id="White_Inner" 
          data-name="White Inner" 
          cx="397.55" 
          cy="397.55" 
          r="343.4" 
          fill="none" 
          stroke="#fff" 
          strokeWidth="20px" 
          strokeMiterlimit="10" 
        />
      </g>
      <g id="Shapes">
        <g id="Camera">
          <path 
            fill="#fdfdfd" 
            d="M277.87,296.9c70.25-26.54,139.91-52.81,209.51-79.24,28.02-10.64,51.4-.39,61.69,27.63,9.71,26.44,19.99,52.7,28.57,79.51,6.76,21.11-3.53,41.47-24.09,50.05-22.48,9.38-45.33,17.87-68.01,26.76-1.77.69-3.49,1.48-5.12,2.18,1.65,26.4-7.25,47.8-28.04,63.5.06.76.02,1.06.12,1.31,3.45,8.64,4.65,20.44,11.03,24.99,6.12,4.36,17.6,1.29,26.73,1.31,29.36.05,58.72.02,88.85.02,0-10.68-.05-20.86.01-31.04.09-15.19,11.35-26.83,26.43-27.24,6.65-.18,13.32-.17,19.98,0,10.11.27,16.8,6.63,16.83,16.52.13,37.19.16,74.38-.01,111.56-.05,10.73-6.57,16.72-17.27,16.81-6.66.06-13.32.05-19.98,0-14.79-.1-25.85-11.25-25.98-26.26-.09-10.82-.05-21.64-.1-32.47,0-.19-.38-.37-1.33-1.25-19.96,0-40.7,0-61.44,0-19.98,0-39.97-.25-59.94.14-8.87.17-13.97-4-16.9-11.65-3.62-9.46-7.14-18.97-10.43-28.54-1.51-4.37-3.55-6.17-8.72-6.35-20.8-.72-35.84-10.85-45.3-30.25-26.29,10.15-52.74,20.34-79.18,30.58-6.13,2.38-12.1,5.18-18.29,7.38-14.25,5.06-23.96,2.36-34.06-9.22-13.82,4.94-27.66,10-41.59,14.83-10.2,3.54-14.05,1.77-17.87-7.98-8.39-21.41-16.73-42.83-24.99-64.29-4.81-12.5-1.92-19.06,10.32-23.91,5.73-2.27,11.52-4.39,18.56-7.06-9.6-7.28-18.21-14-27.03-20.44-4.65-3.4-9.02-6.91-8.01-13.36,1.01-6.5,5.92-9.3,11.66-11.46,37.63-14.19,75.2-28.54,113.41-43.05M250.93,431.54c-.44.11-.88.22-1.31.32.33.57.66,1.14,1.13,2.93,1.67,3.73,3.35,7.46,5.02,11.2,5.68,12.75,10.65,14.3,22.64,6.81-8.93-6.93-17.8-13.8-27.47-21.26M547.45,319.22c-8.23-22.03-16.24-44.14-24.79-66.05-5.11-13.09-11.74-15.48-24.72-10.56-81.37,30.82-162.76,61.57-244.14,92.38-19.02,7.2-37.99,14.55-57.72,22.12,35.5,26.34,70.21,51.82,104.54,77.79,6.37,4.82,11.46,5.11,18.67,2.19,31.47-12.72,63.21-24.78,94.84-37.12,42.32-16.51,84.65-33.01,126.93-49.62,11.1-4.36,13.53-9.95,9.8-21.38-.93-2.86-2.05-5.65-3.41-9.76M199.47,448.74c1.81,4.17,3.62,8.35,5.41,12.47,8.92-3.4,17.33-6.6,25.88-9.86-7-16.41-13.81-32.34-20.64-48.34-8.69,3.38-16.48,6.41-24.43,9.5,4.68,12.04,9.12,23.49,13.77,36.23M617.41,529.04v-65.99h-12.81v92.97h12.81v-26.98M413.36,429.92c-4.62,1.88-9.24,3.75-14.04,5.71,10.06,11.89,21.14,16.12,32.41,11.93,14.99-5.57,20.28-17.97,22.44-33.57-13.74,5.43-26.64,10.53-40.81,15.93h0Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default CameraIcon;